const sortingUsers = (users, id, isFollow) => {
    return(
        users.map(user => {
            if (user.id === id)
                return {...user, followed: isFollow};
            return user
        })
    )
};

export default sortingUsers